import { Game } from './core/Game.ts';
import { initAnalytics, trackPwaInstalled } from './core/Analytics.ts';

window.addEventListener('DOMContentLoaded', () => {
  // Initialize Google Analytics 4 (if measurement ID is provided and consented)
  initAnalytics();

  window.addEventListener('appinstalled', () => {
    trackPwaInstalled();
  });

  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
  if (!canvas) {
    console.error('Canvas element not found');
    return;
  }

  // Initialize the game
  new Game(canvas);

  // Register PWA Service Worker (only in production builds to prevent dev caching)
  if (!import.meta.env.DEV && 'serviceWorker' in navigator && window.location.protocol.startsWith('http')) {
    navigator.serviceWorker.register('./sw.js')
      .then((reg) => {
        reg.update();
        console.log('VIP Tray PWA ServiceWorker active:', reg.scope);
      })
      .catch((err) => {
        console.warn('PWA ServiceWorker registration skipped:', err);
      });
  } else if (import.meta.env.DEV && 'serviceWorker' in navigator) {
    // Unregister stale service workers in dev mode
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) {
        reg.unregister();
      }
    });
  }
});
